import React from "react";
import "../../css/pages/homePage.css";
import "../../css/components/BlogsCard.css";
import Hero from "../designSystem/Hero";
import HeroImage from "../../assets/images/Blog1.jpg";
import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import TertiaryButton from "../designSystem/buttons/TertiaryButton";
import { useNavigate } from "react-router-dom";
import ContactUsPage from "./ContactUsPage";
import { blogPosts } from "../../data/blogPosts";


const BlogsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="home-page">
      <Hero
        title="News & Insights"
        subtitle="BLOG"
        backgroundImage={HeroImage} // Optionally add a hero image
        titleAlign="center"
        subtitleAlign="center"
      />
      <section className="page-section gray-bg">
        <div className="page-section-inner">
          <div className="blog-card-grid">
            {blogPosts.map((post, idx) => (
              <div className="blog-card" key={idx}>
                <div className="blog-card-content">
                  <h3 className="secondary">{post.title}</h3>
                  <div className="divider primary align-left" />
                  <div className="body primary">{post.date || ""}</div>
                  <div className="body primary">{post.excerpt}</div>
                  {/* <a
                  href={post.link}
                  className="see-more-btn"
                  style={{ marginTop: 16 }}
                >
                  <span className="nav gray">READ MORE</span>
                      </a> */}
                  <TertiaryButton onClick={() => navigate(post.link)}>
                    READ MORE
                  </TertiaryButton>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <ContactUsPage />
    </div>
  );
};



export default BlogsPage;
